import type { EditableField } from '@/types/editableField';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EditModeSaveEvent extends EventV2<EditableField[]> {}
